import { render } from "./Tabs.vue?vue&type=template&id=05e1ba1a"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=05e1ba1a&lang=css"
script.render = render

export default script